import React from "react";

import './PersonalBanner.css';

export default function PersonalBanner() {
	return <div className={'personal-banner'}>
		<h1>LARGE EXPERIENTE AT BIG TECH PROJETCTS</h1>
	</div>;
}